<h2 class="row space-between align-center">
    <div class="row gap-8 align-center">
        <div>
            @if(isNew === true){
            <span>New </span>
            }@else{
            <span>Edit </span>
            } Processing Activities
        </div>
    </div>
    <rr-icon name="close" class="pointer" (click)="cancel()"></rr-icon>
</h2>
<div class="row gap-4" *ngIf="isNew === false">
    <span>created: {{ data.activity.createdAt | date : "medium" }}</span>
    @if(data.activity.updatedAt){
    <span>|</span>
    <span>last modified: {{ data.activity.updatedAt | date : "medium" }}</span>
    }
</div>
<form class="w100 row gap-64" [formGroup]="activityFormData">
    <div class="col gap-8 w100">
        <h3>Zwecke der Verarbeitung</h3>
        <rr-input
            label="Zweck / Name"
            formControlName="processingPurpose"
            [required]="true"
        ></rr-input>
        <rr-textarea
            label="Beschreibung"
            formControlName="processingDescription"
            [required]="true"
        ></rr-textarea>
        <rr-select
            label="Rechtsgrundlage"
            [options]="_gdprLegalBases"
            formControlName="legalBasis"
            optionValue="value"
            optionName="label"
            #legalBasisSelect
            [required]="true"
        ></rr-select>
        <rr-textarea
            *ngIf="
                legalBasisSelect?.control?.value ===
                LegalBasis.LEGITIMATE_INTEREST
            "
            [required]="true"
            label="Bei berechtigtem Interesse: Beschreibung"
            formControlName="legitimateInterestDescription"
        ></rr-textarea>
        <h3>Name und Kontaktdaten des Verantwortlichen</h3>
        <rr-input
            label="Name Verantwortlicher"
            [required]="true"
            formControlName="controllerName"
        ></rr-input>
        <rr-input
            [required]="true"
            type="email"
            label="Email Verantwortlicher"
            formControlName="controllerContact"
        ></rr-input>
        <rr-input
            label="Name Datenschutzbeauftragter"
            formControlName="dpoName"
        ></rr-input>
        <rr-input
            type="email"
            label="Email Datenschutzbeauftragter"
            formControlName="dpoContact"
        ></rr-input>
        <h3>Kategorien betroffener Personen und Daten</h3>
        <div class="col gap-8">
            <h4>Kategorien betroffener Personen</h4>
            <div class="w100 row wrap-true gap-8">
                @for(cat of selectableGdprDataSubjectCategories; track cat){
                @if(cat.selected){
                <rr-badge
                    tone="success"
                    class="pointer"
                    icon="check"
                    (click)="toggleCat(cat, 'dataSubjectCategories')"
                    >{{ cat.label }}</rr-badge
                >
                }@else{
                <rr-badge
                    class="pointer"
                    (click)="toggleCat(cat, 'dataSubjectCategories')"
                    >{{ cat.label }}</rr-badge
                >
                } }
            </div>
            <h4>Kategorien personenbezogener Daten</h4>
            <div class="w100 row wrap-true gap-8">
                @for(cat of selectableGdprCategories; track cat){
                @if(cat.selected){
                <rr-badge
                    tone="success"
                    class="pointer"
                    icon="check"
                    (click)="toggleCat(cat, 'dataCategories')"
                    >{{ cat.label }}</rr-badge
                >
                }@else{
                <rr-badge
                    class="pointer"
                    (click)="toggleCat(cat, 'dataCategories')"
                    >{{ cat.label }}</rr-badge
                >
                } }
            </div>
            <div class="col gap-16">
                <h4>Sonstige Kategorien</h4>
                <div class="">
                    <mat-expansion-panel [hideToggle]="false" class="w100">
                        <mat-expansion-panel-header
                            >Besondere Kategorien personenbezogener Daten (Art.
                            9 DSGVO)</mat-expansion-panel-header
                        >
                        <div>
                            Besondere Kategorien personenbezogener Daten sind
                            besonders sensible Daten, deren Verarbeitung
                            grundsätzlich verboten ist:
                            <ul>
                                <li>
                                    <strong
                                        >Rassische und ethnische
                                        Herkunft</strong
                                    ><br />
                                    <span
                                        >Hautfarbe, Nationalität, ethnische
                                        Zugehörigkeit</span
                                    >
                                </li>
                                <li>
                                    <strong>Politische Meinungen</strong><br />
                                    <span
                                        >Parteizugehörigkeit, politische
                                        Überzeugungen</span
                                    >
                                </li>
                                <li>
                                    <strong
                                        >Religiöse oder weltanschauliche
                                        Überzeugungen</strong
                                    ><br />
                                    <span
                                        >Religionszugehörigkeit, Atheismus,
                                        philosophische Überzeugungen</span
                                    >
                                </li>
                                <li>
                                    <strong>Gewerkschaftszugehörigkeit</strong
                                    ><br />
                                    <span
                                        >Mitgliedschaft in Gewerkschaften</span
                                    >
                                </li>
                                <li>
                                    <strong>Genetische Daten</strong><br />
                                    <span>DNA-Analysen, Erbinformationen</span>
                                </li>
                                <li>
                                    <strong
                                        >Biometrische Daten zur eindeutigen
                                        Identifizierung</strong
                                    ><br />
                                    <span
                                        >Fingerabdrücke, Gesichtserkennung,
                                        Iris-Scan, Stimmerkennung</span
                                    >
                                </li>
                                <li>
                                    <strong>Gesundheitsdaten</strong><br />
                                    <span
                                        >Krankenakten, Diagnosen, Medikamente,
                                        Behinderungen</span
                                    >
                                </li>
                                <li>
                                    <strong
                                        >Daten zum Sexualleben oder zur
                                        sexuellen Orientierung</strong
                                    ><br />
                                    <span
                                        >Sexuelle Präferenzen, Beziehungsstatus
                                        in diesem Kontext</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </mat-expansion-panel>
                    <rr-checkbox
                        formControlName="isSpecialCategory"
                        [checked]="
                            activityFormData.value.isSpecialCategory || false
                        "
                        >Wenn zutreffend bitte ankreuzen
                    </rr-checkbox>
                </div>
                <div class="">
                    <mat-expansion-panel [hideToggle]="false">
                        <mat-expansion-panel-header
                            >Strafrechtliche Daten (Art. 10
                            DSGVO)</mat-expansion-panel-header
                        >
                        <div>
                            Besondere Kategorien personenbezogener Daten sind
                            besonders sensible Daten, deren Verarbeitung
                            grundsätzlich verboten ist:
                            <ul>
                                <li>
                                    <strong
                                        >Strafrechtliche Verurteilungen</strong
                                    ><br />
                                    <span
                                        >Gerichtsurteile, Vorstrafen,
                                        Freiheitsstrafen, Geldstrafen</span
                                    >
                                </li>
                                <li>
                                    <strong>Straftaten</strong><br />
                                    <span
                                        >Laufende Strafverfahren,
                                        Ermittlungsverfahren, Anzeigen,
                                        Anklagen</span
                                    >
                                </li>
                                <li>
                                    <strong
                                        >Damit zusammenhängende
                                        Sicherungsmaßregeln</strong
                                    ><br />
                                    <span
                                        >Führungsaufsicht, Berufsverbote,
                                        Bewährungsauflagen</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </mat-expansion-panel>
                    <rr-checkbox
                        formControlName="isCriminalData"
                        [checked]="
                            activityFormData.value.isCriminalData || false
                        "
                        >Wenn zutreffend bitte ankreuzen
                    </rr-checkbox>
                </div>
            </div>
        </div>
        <h3>Empfänger der Daten</h3>
        <div class="col gap-16 recipientarea w100">
            <div class="col gap-4 recipientlist w100">
                @if( activityFormData.value.recipients &&
                activityFormData.value.recipients.length === 0 ){
                <span>Es wurden noch keine Empfänger hinzugefügt.</span>
                } @for(rec of activityFormData.value.recipients || []; track
                rec){
                <div class="row card align-center space-between gap-8 w100">
                    <div class="col">
                        <span class="strong">{{ rec.name }}</span>
                        <span class="tiny">{{ rec.category }}</span>
                    </div>
                    <rr-icon
                        name="trash"
                        (click)="removeRecipient(rec)"
                    ></rr-icon>
                </div>
                }
            </div>
            <div
                class="recipientaddarea card w100 col gap-4"
                [formGroup]="newRecipient"
            >
                <rr-input
                    label="Name des Empfängers"
                    formControlName="name"
                ></rr-input>
                <div class="row gap-4 align-end w100">
                    <rr-select
                        formControlName="category"
                        [options]="_gdprRecipientCategories"
                        optionName="label"
                        optionValue="value"
                        label="Kategorie des Empfängers"
                    ></rr-select>
                    <rr-select
                        label="Land des Empfängers"
                        formControlName="country"
                        [options]="_gdprThirdCountries"
                        #countryselect
                        optionName="label"
                        optionValue="value"
                        (ngModelChange)="
                            isThirdCountry(countryselect?.control?.value)
                        "
                    ></rr-select>
                </div>
                <div class="row gap-8 align-center w100 align-end">
                    <rr-checkbox
                        formControlName="isThirdCountry"
                        [checked]="newRecipient.value.isThirdCountry || false"
                        >Drittlandübermittlung</rr-checkbox
                    >
                    @if(newRecipient.value.isThirdCountry === true){
                    <rr-select
                        [options]="_gdprThirdCountryGuarantees"
                        formControlName="thirdCountryGuarantees"
                        optionValue="value"
                        optionName="label"
                        label="Garantien"
                    ></rr-select>
                    }
                </div>
                <rr-divider></rr-divider>
                <div class="w100 row justify-end">
                    <rr-btn
                        type="Secondary"
                        size="Small"
                        (click)="addRecipient()"
                        >Hinzufügen</rr-btn
                    >
                </div>
            </div>
        </div>
    </div>
    <div class="col gap-8 w100">
        <h3>Löschfristen</h3>
        <h4>Fristen (das was früher eintritt)</h4>
        <div class="w100 row wrap-true gap-8">
            @for(cat of selectableGdprDeletionPeriods; track cat){
            @if(cat.selected){
            <rr-badge
                tone="success"
                class="pointer"
                icon="check"
                (click)="toggleCat(cat, 'dataCategories')"
                >{{ cat.label }}</rr-badge
            >
            }@else{
            <rr-badge
                class="pointer"
                (click)="toggleCat(cat, 'dataCategories')"
                >{{ cat.label }}</rr-badge
            >
            } }
        </div>
        <h4>Kriterien (das was früher eintritt)</h4>
        <div class="w100 row wrap-true gap-8">
            @for(cat of selectableGdprDeletionCriteria; track cat){
            @if(cat.selected){
            <rr-badge
                tone="success"
                class="pointer"
                icon="check"
                (click)="toggleCat(cat, 'dataCategories')"
                >{{ cat.label }}</rr-badge
            >
            }@else{
            <rr-badge
                class="pointer"
                (click)="toggleCat(cat, 'dataCategories')"
                >{{ cat.label }}</rr-badge
            >
            } }
        </div>
        <h3>Technische und organisatorische Maßnahmen</h3>
        <div formGroupName="technicalMeasures" class="w100 col gap-8">
            <rr-checkbox formControlName="backup">Backup vorhanden</rr-checkbox>
            <rr-checkbox formControlName="training"
                >Schulung der Mitarbeiter</rr-checkbox
            >
            <rr-checkbox formControlName="encryption"
                >Verschlüsselung der Daten
            </rr-checkbox>
            <rr-checkbox formControlName="accessControl"
                >Zugriffskontrolle
            </rr-checkbox>
            <rr-checkbox formControlName="securityTesting"
                >Sicherheitstests
            </rr-checkbox>
            <rr-checkbox formControlName="dataMinimization"
                >Datenminimierung
            </rr-checkbox>
            <rr-checkbox formControlName="incidentResponse"
                >Notfallplan
            </rr-checkbox>
            <rr-checkbox formControlName="pseudonymization"
                >Pseudonymisierung
            </rr-checkbox>
        </div>
        <h3>Zusätzliche Metadaten</h3>
        <rr-checkbox formControlName="isRegularProcessing"
            >Regelmäßige Verarbeitung des Prozesses
        </rr-checkbox>

        <rr-select
            label="Risikobewertung"
            [options]="_gdprRiskLevels"
            formControlName="riskAssessment"
            optionValue="value"
            optionName="label"
        ></rr-select>
        <mat-expansion-panel [hideToggle]="false">
            <mat-expansion-panel-header
                >Datenschutz-Folgenabschätzung</mat-expansion-panel-header
            >
            <strong>Gemäß Art. 35 DSGVO ist eine DSFA erforderlich, </strong
            ><br />

            wenn eine Verarbeitung voraussichtlich ein hohes Risiko für die
            Rechte und Freiheiten natürlicher Personen zur Folge hat.
            <br /><br />
            <strong>Wann ist eine DSFA Pflicht?</strong>
            <ul>
                <li>
                    Systematische und umfangreiche Bewertung persönlicher
                    Aspekte
                    <ul>
                        <li>Profiling mit automatisierten Entscheidungen</li>
                        <li>
                            Scoring-Verfahren (z.B. Kreditwürdigkeit,
                            Gesundheitsrisiken)
                        </li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>
                    Umfangreiche Verarbeitung besonderer Kategorien (Art. 9)
                    <ul>
                        <li>Gesundheitsdaten, genetische/biometrische Daten</li>
                        <li>Politische Meinungen, religiöse Überzeugungen</li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>
                    Systematische umfangreiche Überwachung öffentlich
                    zugänglicher Bereiche
                    <ul>
                        <li>Videoüberwachung großer Bereiche</li>
                        <li>Tracking von Bewegungsdaten</li>
                    </ul>
                </li>
            </ul>
        </mat-expansion-panel>
        <rr-checkbox formControlName="dataProtectionImpactAssessment"
            >Wenn DSFA notwendig bitte ankreuzen
        </rr-checkbox>
        <rr-select
            label="Status"
            [options]="status"
            formControlName="status"
            optionValue="value"
            [required]="true"
            optionName="label"
            [preselectedValue]="activityFormData.status"
        ></rr-select>
    </div>
</form>
<div class="btnrow align-end justify-end row gap-8 w100">
    <rr-btn (click)="cancel()">Cancel</rr-btn>
    <rr-btn type="Primary" (click)="submitActivity()">Save Activity</rr-btn>
</div>
